import React from 'react';
import {Store} from '../../models/store.model';
import {AppText, AppCardTitle, AppLabelText} from '../../../../Presentation/components/ui/Typography';
import {DollarSign, CheckCircle, AlertTriangle, Clock} from 'lucide-react';

interface StoreStatusInfoProps {
  store: Store;
}

export const StoreStatusInfo: React.FC<StoreStatusInfoProps> = ({store}) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'no_transactions': return 'px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200';
      case 'overdue': return 'px-2 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200';
      case 'partial': return 'px-2 py-1 rounded-full text-xs font-medium bg-orange-50 text-orange-700 border border-orange-200';
      case 'paid': return 'px-2 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200';
      default: return 'px-2 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-600 border border-gray-200';
    }
  };

  const getStatusText = (status: string) => {
    switch (status.toLowerCase()) {
      case 'no_transactions': return 'جديد';
      case 'overdue': return 'متأخر';
      case 'partial': return 'جزئي';
      case 'paid': return 'مدفوع';
      default: return 'غير محدد';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'paid': return <CheckCircle className="w-4 h-4" />;
      case 'overdue': return <AlertTriangle className="w-4 h-4" />;
      default: return <Clock className="w-4 h-4" />;
    }
  };

  return (
    <div className="space-y-4">
      <AppCardTitle className="border-b pb-2">حالة المتجر</AppCardTitle>

      {/* حالة الدفع فقط (تم إزالة معلومات المخزون) */}
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border border-orange-200">
          <div className="flex items-center gap-3 mb-2">
            <DollarSign className="w-5 h-5 text-orange-600" />
            <AppLabelText className="text-orange-700 font-medium">حالة الدفع</AppLabelText>
          </div>
          <div className="flex items-center gap-2">
            {getStatusIcon(store.paymentStatus)}
            <span className={`px-3 py-1 rounded-full text-sm font-bold border ${getStatusColor(store.paymentStatus)}`}>
              {getStatusText(store.paymentStatus)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};


